(function($) {
  <!-- Initialize sale note visibility on page load -->
  $(document).ready(function() {
    const selectedChip = $('.product-form__chip.selected');
    if (selectedChip.length > 0) {
      const variantID = selectedChip.attr('data-variant');
      checkVariantIDSaleNote(variantID, selectedChip);
    }
  });
  
  $('.product-form__chips').click(function(){
    $(this).toggleClass('open');
  });
  $('.product-form__chips a').click(function(e){
    e.preventDefault();
    if($(this).hasClass("selected") || $(this).parent().find(".selected").length > 0) {
      if($(this).hasClass("default")) {
        $(this).removeClass("selected");
        $(this).parent().removeClass("get-selected");
      } else {
        $(this).parent().addClass("get-selected");
      }
    } else {
      // $(this).parent().removeClass("get-selected");
    }

    var variantID = $(this).attr('data-variant')
    checkVariantIDSaleNote(variantID, $(this))
  });

  <!-- Check for order note -->
  function checkVariantIDSaleNote(variantID, selectedChip){
    <!-- Check data-primary-location and data-secondary-location attributes -->
    const primaryLocation = $(selectedChip).attr('data-primary-location');
    const secondaryLocation = $(selectedChip).attr('data-secondary-location');
    
    const productContentParent = $(selectedChip).closest('.product__details')[0];
    const productSaleNote = $(productContentParent).find('.product-sale-note')[0];
    
    <!-- Find the order note related to the variantID -->
    if(document.body.querySelector('[data-product-sale-note-json]')){

      var jsonData = JSON.parse(document.body.querySelector('[data-product-sale-note-json]').innerHTML);
      variantsSaleNotes = jsonData['order_notes'] || {};

      var variantSaleNote = variantID ? this.variantsSaleNotes[variantID] : null;

      const saleNoteTextElement = $(productContentParent).find('.sale-note-text')[0];
      const saleNoteProperty = $(productContentParent).find('#sale-note')[0];
      <!-- Show Note -->
      $(saleNoteTextElement).addClass('active')
      if (saleNoteTextElement ) {
        const attributeName = 'name';
        const attributeValue = 'properties[Order Note]';
        
        <!-- Don't add sale note to line item properties for secondary location variants -->
        const isSecondaryLocation = primaryLocation === 'false' && secondaryLocation === 'true';

        const isInStock = primaryLocation === 'true';
        const isPreOrder = primaryLocation === 'false' && secondaryLocation === 'true';
        const isUnavailable = primaryLocation === 'false' && secondaryLocation === 'false';
        const productNote = variantSaleNote ? variantSaleNote['product_note'] : null;
        const variantNote = variantSaleNote ? variantSaleNote['variant_note'] : null;

        // Determine which note to show
        let noteToShow = null;
        if (isUnavailable) {
          // Completely unavailable - don't show any notes
          noteToShow = null;
        } else if (isInStock) {
          // In stock - show product-level note only
          noteToShow = productNote;
        } else if (isPreOrder) {
          // Pre-order - show variant note if exists, otherwise product note
          noteToShow = variantNote || productNote;
        } else {
          // Default to product note
          noteToShow = productNote;
        }

        if (noteToShow && noteToShow !== '') {
          // Show the appropriate note
          $(productSaleNote).show();
          saleNoteTextElement.style.display = '';
          saleNoteTextElement.innerHTML = noteToShow;
          saleNoteProperty.innerHTML = noteToShow;
          saleNoteProperty.setAttribute(attributeName, attributeValue);
        } else {
          // No note to show - hide everything
          $(productSaleNote).hide();
            saleNoteTextElement.innerHTML = '';
            saleNoteTextElement.style.display = 'none';
            saleNoteProperty.innerHTML = '';
            saleNoteProperty.removeAttribute('name');
        }
      }
    }
  }

  // Function to restore focus after swatch change
  function restoreFocusAfterSwatchChange(productHandle) {
    // Find all swatch elements with matching data-handle
    var $allSwatches = $(`.product-color__swatch[data-handle="${productHandle}"]`);

    // Find the visible swatch element (the one that's actually displayed)
    var $visibleSwatch = null;
    $allSwatches.each(function() {
      var $this = $(this);
      // Check if element is visible and within a visible container
      if ($this.is(':visible') && $this.closest('.shopify-section').is(':visible')) {
        $visibleSwatch = $this;
        return false; // break the loop
      }
    });

    // If no visible swatch found, try to use the first one with selected class
    if (!$visibleSwatch && $allSwatches.length > 0) {
      $allSwatches.each(function() {
        if ($(this).hasClass('selected')) {
          $visibleSwatch = $(this);
          return false;
        }
      });
    }

    // If still no match, use the first available swatch
    if (!$visibleSwatch && $allSwatches.length > 0) {
      $visibleSwatch = $allSwatches.first();
    }

    if ($visibleSwatch && $visibleSwatch.length > 0) {
      // Restore focus to the element
      $visibleSwatch[0].focus();

      // Update aria-pressed states for all visible swatches
      $('.product-color__swatch:visible').attr('aria-pressed', 'false');
      $visibleSwatch.attr('aria-pressed', 'true');

      // Optionally scroll into view if element is not visible in viewport
      var rect = $visibleSwatch[0].getBoundingClientRect();
      if (rect.top < 0 || rect.bottom > window.innerHeight) {
        $visibleSwatch[0].scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }

  /*=====  Color watch on Group PDP  =====*/
  document.body.addEventListener('click', handleSwatch);
  document.body.addEventListener('keydown', handleSwatch);

  function handleSwatch(e) {
    if (e.type === 'click' || (e.type === 'keydown' && (e.key === 'Enter' || e.keyCode === 13))) {
      var clickedElement = e.target.closest('.product-color__swatch');
      if (!clickedElement) return;

      var parentEl = clickedElement.closest('.shopify-section');
      var productHandle = clickedElement.getAttribute('data-handle');

      localStorage.setItem('lastSwatch', productHandle);

      if (!clickedElement.classList.contains('selected')) {
        parentEl.querySelectorAll('[class*="js-form-"]').forEach(el => el.style.display = 'none');
        var selectedProduct = parentEl.querySelector('.js-form-' + productHandle);
        if (selectedProduct) selectedProduct.style.display = '';

        var selectedSize = selectedProduct.querySelector('.Size .product-form__chip.selected');
        if (selectedSize) {
          selectedSize.click();
        } else {
          var shipDate = selectedProduct.querySelector('.ship_date');
          if (shipDate) shipDate.innerHTML = '';
        }

        var useMetaBlocks = true;
        swatchMeta.forEach(metavalue => {
          if (metavalue.handle === productHandle) {
            useMetaBlocks = metavalue.useMetaBlocks;
          }
        });

        document.querySelectorAll('.js-color-swatch-block').forEach(el => el.style.display = 'none');

        if (useMetaBlocks) {
          document.querySelectorAll(`.js-color-swatch-block.js-use-metablocks[data-handle="${productHandle}"]`).forEach(el => el.style.display = '');
        } else {
          document.querySelectorAll(`.js-color-swatch-block.js-none-metablocks[data-handle="${productHandle}"]`).forEach(el => el.style.display = '');
          document.querySelectorAll(`.js-color-swatch-block.collage`).forEach(el => el.style.display = '');
        }

        var pageTitle = selectedProduct.getAttribute('data-section-title');
        document.title = pageTitle;
        window.history.pushState("", pageTitle, '/products/' + productHandle);

        if (e.type === 'keydown') {
          setTimeout(function () {
            parentEl.querySelectorAll('.product-color__swatch').forEach(function (el) {
              el.setAttribute('aria-pressed', 'false');
              el.classList.remove('selected');

              if (el.dataset.handle === clickedElement.dataset.handle) {
                el.setAttribute('aria-pressed', 'true');
                el.classList.add('selected');
              }
            });

            clickedElement.focus();

            var focusEvent = new Event('focusRestored');
            clickedElement.dispatchEvent(focusEvent);

            restoreFocusAfterSwatchChange(productHandle);
          }, 0);
        } else if (e.type === 'click') {
          parentEl.querySelectorAll('.product-color__swatch').forEach(function (el) {
            el.setAttribute('aria-pressed', 'false');
            el.classList.remove('selected');

            if (el.dataset.handle === clickedElement.dataset.handle) {
              el.setAttribute('aria-pressed', 'true');
              el.classList.add('selected');
            }
          });
        }
      }
    }
  }

  // On page load, restore focus if swatch was saved
  $(document).ready(function() {
    setTimeout(function() {
      var lastSwatch = localStorage.getItem('lastSwatch');
      if (lastSwatch) {
        restoreFocusAfterSwatchChange(lastSwatch);
        // Clear localStorage after use
        localStorage.removeItem('lastSwatch');
      }
    }, 100);
  });

  /*=====  Variant selection on the Quick Add popup  =====*/
  $('body').on('click', '.quick-cart__configure .quick-add__form [data-button]', function(event) {
    var $this = $(this),
        $parent = $this.closest('[data-option-buttons]'),
        $select = $parent.find('select');

    event.preventDefault();

    var option_value = $this.data('button');
    $parent.find(`[data-button]`).removeClass('selected');
    $parent.find(`[data-button="${option_value}"]`).addClass('selected');

    $select.find(`option[value="${option_value}"]`).attr('selected', true);
    $select.trigger('change');
  })

  /*=====  Bundle Product  =====*/
  .on('click', '.bundle_swatch .swatch-element label', function() {
    var selectedVariant = $(this).find("span").text();
    $(this).closest(".swatch").find(".option_title_new .option_value").text(selectedVariant);
  })

  /*=====  Add To Cart  =====*/
  .on('click', `.custom-add-to-cart`, function(event) {
    event.preventDefault();

    var flexboxData      = '';
    var $addToCartBtn    = $(this);
    var $addToCartForm   = $addToCartBtn.closest("form");
    var blazerVariantId  = $addToCartForm.find(".blazer_variant input:checked").attr("data-variant-id");
    var pantsVariantId   = $addToCartForm.find(".pants_variant input:checked").attr("data-variant-id");
    var vastAvailability = $addToCartForm.find(".vast_variant input").length;

    var arr = [];
    var quantity = 1;
    if ( $(`[name="quantity"]`).length ) {
      quantity = $(`[name="quantity"]`).val();
    }

    if ( vastAvailability ) {
      var vastVariantId = $(".vast_variant input:checked").attr("data-variant-id");

      if ( blazerVariantId == undefined || pantsVariantId == undefined || vastVariantId == undefined ) {
        return false;
      }

      var blazerData = {
        "quantity": quantity,
        "id": blazerVariantId
      };
      var pantsData = {
        "quantity": quantity,
        "id": pantsVariantId
      };
      var vastData = {
        "quantity": quantity,
        "id": vastVariantId
      };

      arr.push(blazerData);
      arr.push(pantsData);
      arr.push(vastData);
    } else {
      if ( blazerVariantId == undefined || pantsVariantId == undefined ) {
        return false;
      }

      var blazerData = {
        "quantity": quantity,
        "id": blazerVariantId
      };
      var pantsData = {
        "quantity": quantity,
        "id": pantsVariantId
      };

      arr.push(blazerData);
      arr.push(pantsData);
    }

    // Add bundle product into Cart
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: {
        items: arr
      },
      beforeSend: function() {
        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
        $addToCartBtn.find('span');
      },
      success: function(items) {
        $.each(items.items, function (i,item) {
          flexboxData += '<div class="box"><div class="product_image"><img class="lazyload" data-src="' + item.image.replace(/(\.[^.]*)$/, "_grande$1").replace('https:', '') + '" alt="' + item.title + '" /></div><div class="cart_notification_content"><div class="notify-check"><h4><svg width="12" height="12" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg> Just Added</h4> <div><strong>' + item.title + '</strong></div><p>' + item.quantity + ' x ' + '<span class="money">' + Shopify.formatMoney(item.price, $addToCartForm.data('money-format')) + '</span></p><div class="buttons"><a class="btn btn--full product-form__cart-submit" href="/checkout" style="min-width: 0">Checkout</a><span class="continue_shopping">or <a href="#" onclick="event.preventDefault();$.fancybox.close();">Continue Shopping</a></span></div></div></div></div>';
        });

        $addToCartBtn.find('span').text("Just Added");

        if ($(window).width() <= 767) {
          var padding = [20, 10, 20, 0];
        } else {
          var padding = [20, 40, 20, 40];
        }

        window.setTimeout(function() {
          $.fancybox.close();
          $.fancybox($('<div class="container section cart_notification" style="width: inherit">'+ flexboxData +'</div>'), {
            padding: padding
          });
        }, 500)

        window.setTimeout(function() {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text($addToCartBtn.data('label'));
        }, 1000);

      },
      error: function(XMLHttpRequest) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
        $('.warning').remove();

        var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
        $addToCartForm.after(warning);
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('span').text("Add to Cart");
      }
    });

    return false;
  });

  window.setTimeout(function() {
    var s = document.createElement('script'); // Create a script element
    s.type = "text/javascript";               // optional in html5
    s.async = false;                           // asynchronous? true/false
    s.src = "//a.klaviyo.com/media/js/onsite/onsite.js";
    s.onload = function() {
      // don't run the setter, messes up all
      // access methods
      // var klaviyo = klaviyo || [];

      klaviyo.init({
        account: "QkCWPk",
        list: 'QyYtHn',
        platform: "shopify"
      });

      klaviyo.enable("backinstock",{
        trigger: {
          product_page_text: "Notify Me When Available",
          product_page_class: "btn btn--full product-form__cart-submit",
          replace_anchor: false
        },
        modal: {
          headline: "{product_name}",
          body_content: "Enter your email to be notified when this item comes back in stock.",
          email_field_label: "Email",
          button_label: "Notify Me When Available",
          subscription_success_label: "You're in! We'll let you know when it's back.",
          footer_content: '',
          drop_background_color: "#000",
          background_color: "#fff",
          text_color: "#222",
          button_text_color: "#fff",
          button_background_color: "#212A2F",
          close_button_color: "#ccc",
          error_background_color: "#fcd6d7",
          error_text_color: "#C72E2F",
          success_background_color: "#d3efcd",
          success_text_color: "#1B9500"
        }
      });
    };


    // size guide popup

    $(document).on('click','.btn-sizeguide-trigger',(e)=>{
      $('body').addClass('open-size-guide-popup');
      $('html').addClass('open-size-guide-popup');
    })
    $(document).on('click','.size-guide-overlay',(e)=>{
      $('body').removeClass('open-size-guide-popup');
      $('html').removeClass('open-size-guide-popup');
    })
    $(document).on('click','.close-size-guide-popup',(e)=>{
      $('body').removeClass('open-size-guide-popup');
      $('html').removeClass('open-size-guide-popup');
    })

    // size chart modal desktop - using same classes as the existing size guide popup
    var lastFocusedElement = null;
    var currentOpenButton = null;
    var usingKeyboard = false;
    var mouseDownTime = 0;
    
    // Track when user is navigating with keyboard vs mouse
    $(document).on('keydown', function(e) {
      if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ' || e.key.startsWith('Arrow')) {
        usingKeyboard = true;
      }
    });
    
    $(document).on('mousedown', function(e) {
      usingKeyboard = false;
      mouseDownTime = Date.now();
      // Remove focus class from all elements when using mouse
      $('.focus').removeClass('focus');
    });
    
    $(document).on('click', function(e) {
      usingKeyboard = false;
      // Remove focus class from clicked element and any that might have received it
      $(e.target).removeClass('focus');
    });
    
    // close size chart modal (desktop and mobile) when clicking overlay or close button
    $(document).on('click','.size-chart-modal-desktop .size-guide-overlay, .size-chart-modal-desktop .close-size-guide-popup, .size-chart-modal-mobile .size-guide-overlay, .size-chart-modal-mobile .close-size-guide-popup',(e)=>{
      var $modal = $(e.target).closest('.size-chart-modal-desktop, .size-chart-modal-mobile');
      $modal.attr('hidden', 'hidden').removeAttr('tabindex');
      $('body').removeClass('open-size-guide-popup');
      $('html').removeClass('open-size-guide-popup');
      
      // Reset aria-expanded on the specific button that opened the modal
      if (currentOpenButton) {
        $(currentOpenButton).attr('aria-expanded', 'false');
        currentOpenButton = null;
      }
      
      // Restore focus to the button that opened the modal (only if user was using keyboard)
      if (lastFocusedElement && usingKeyboard) {
        lastFocusedElement.focus();
        lastFocusedElement = null;
      } else {
        lastFocusedElement = null;
      }
    })
    
    // Handle Enter key on close button (desktop and mobile)
    $(document).on('keydown', '.size-chart-modal-desktop .close-size-guide-popup, .size-chart-modal-mobile .close-size-guide-popup', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        $(this).click();
      }
    })
    
    // Initialize size guide table navigation when modal opens
    function initializeSizeGuideTableNavigation(modal) {
      if (!modal) return;
      const table = modal.querySelector('.size-guide-table');
      if (!table) return;
      
      // Remove any existing listeners to prevent duplicates first
      const existingCells = table.querySelectorAll('th[tabindex="0"], td[tabindex="0"]');
      existingCells.forEach((cell) => {
        const newCell = cell.cloneNode(true);
        cell.parentNode.replaceChild(newCell, cell);
      });
      
      // Now query the fresh cells and set up navigation
      const focusableElements = table.querySelectorAll('th[tabindex="0"], td[tabindex="0"]');
      const cells = Array.from(focusableElements);
      const rows = [];
      let currentRow = [];
      
      // Group cells by table rows
      cells.forEach((cell) => {
        const row = cell.closest('tr');
        if (currentRow.length === 0 || currentRow[0].closest('tr') === row) {
          currentRow.push(cell);
        } else {
          rows.push([...currentRow]);
          currentRow = [cell];
        }
      });
      if (currentRow.length > 0) {
        rows.push(currentRow);
      }
      
      function getCurrentPosition(element) {
        for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
          const colIndex = rows[rowIndex].indexOf(element);
          if (colIndex !== -1) {
            return { row: rowIndex, col: colIndex };
          }
        }
        return { row: 0, col: 0 };
      }
      
      function focusCell(rowIndex, colIndex) {
        if (rowIndex >= 0 && rowIndex < rows.length && 
            colIndex >= 0 && colIndex < rows[rowIndex].length) {
          rows[rowIndex][colIndex].focus();
          return true;
        }
        return false;
      }
      
      // Add keyboard event listeners to the fresh cells
      cells.forEach((cell) => {
        cell.addEventListener('keydown', function(event) {
          const position = getCurrentPosition(this);
          let handled = false;
          
          switch (event.key) {
            case 'ArrowRight':
              handled = focusCell(position.row, position.col + 1);
              break;
            case 'ArrowLeft':
              handled = focusCell(position.row, position.col - 1);
              break;
            case 'ArrowDown':
              handled = focusCell(position.row + 1, position.col);
              break;
            case 'ArrowUp':
              handled = focusCell(position.row - 1, position.col);
              break;
            case 'Home':
              if (event.ctrlKey) {
                handled = focusCell(0, 0);
              } else {
                handled = focusCell(position.row, 0);
              }
              break;
            case 'End':
              if (event.ctrlKey) {
                handled = focusCell(rows.length - 1, rows[rows.length - 1].length - 1);
              } else {
                handled = focusCell(position.row, rows[position.row].length - 1);
              }
              break;
          }
          
          if (handled) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
      });
    }
    
    // Initialize table navigation when modal is opened
    $(document).on('click','.size-chart-button-desktop',(e)=>{
      e.preventDefault();
      
      // Find the target modal using data attribute
      var modalTarget = $(e.currentTarget).attr('data-modal-target');
      var $modal = $('.size-chart-modal-desktop[data-modal-id="' + modalTarget + '"], .size-chart-modal-mobile[data-modal-id="' + modalTarget + '"]');
      
      if ($modal.length === 0) return;
      
      // Store references to the button that was clicked
      lastFocusedElement = document.activeElement;
      currentOpenButton = e.currentTarget;
      
      // Reset all buttons with this class to false, then set only the clicked one to true
      $('.size-chart-button-desktop').attr('aria-expanded', 'false');
      $(currentOpenButton).attr('aria-expanded', 'true');
      
      // Open the modal
      $modal.removeAttr('hidden').attr('tabindex', '-1');
      $('body').addClass('open-size-guide-popup');
      $('html').addClass('open-size-guide-popup');
      
      // Initialize table navigation
      setTimeout(function() {
        initializeSizeGuideTableNavigation($modal[0]);
        
        var modal = $modal[0];
        
        // Only show focus if user was navigating with keyboard
        if (usingKeyboard) {
          modal.focus();
          
          var closeBtn = $modal.find('.close-size-guide-popup')[0];
          if (closeBtn && !closeBtn.hasAttribute('tabindex')) {
            closeBtn.setAttribute('tabindex', '0');
          }
          if (closeBtn) {
            closeBtn.focus();
          }
        } else {
          // Still set tabindex for keyboard navigation later, but don't focus
          var closeBtn = $modal.find('.close-size-guide-popup')[0];
          if (closeBtn && !closeBtn.hasAttribute('tabindex')) {
            closeBtn.setAttribute('tabindex', '0');
          }
        }
      }, 100);
    })
    
    // Focus trap for size-chart-modal-desktop
    $(document).on('keydown', function(e) {
      // Find the modal that contains the currently focused element
      var activeModal = null;
      var openModals = $('.size-chart-modal-desktop:not([hidden]), .size-chart-modal-mobile:not([hidden])');
      
      openModals.each(function() {
        if (this.contains(document.activeElement)) {
          activeModal = this;
          return false; // break out of each loop
        }
      });
      
      // If no modal contains the active element, use the first open modal
      if (!activeModal && openModals.length > 0) {
        activeModal = openModals[0];
      }
      
      if (activeModal) {
        // Close on Escape key
        if (e.key === 'Escape') {
          e.preventDefault();
          $(activeModal).find('.close-size-guide-popup').click();
          return;
        }
        
        // Handle Tab key for focus trap
        if (e.key === 'Tab') {
          // Get all focusable elements within the modal
          var focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
          var focusableElements = activeModal.querySelectorAll(focusableSelectors);
          var focusableArray = Array.from(focusableElements).filter(function(el) {
            // Filter out elements that are not visible or disabled
            return !el.disabled && el.offsetParent !== null;
          });
          
          if (focusableArray.length === 0) return;
          
          var firstFocusable = focusableArray[0];
          var lastFocusable = focusableArray[focusableArray.length - 1];
          
          if (e.shiftKey) { // Shift + Tab
            if (document.activeElement === firstFocusable) {
              e.preventDefault();
              lastFocusable.focus();
            }
          } else { // Tab
            if (document.activeElement === lastFocusable) {
              e.preventDefault();
              firstFocusable.focus();
            }
          }
        }
      }
    })
    
    // Add focus class management for all focusable elements
    $(document).on('focusin', function(e) {
      // Check if focus happened shortly after a mouse interaction
      var timeSinceMouseDown = Date.now() - mouseDownTime;
      var isRecentMouseInteraction = timeSinceMouseDown < 100; // 100ms threshold
      
      // Add focus class only if user is navigating with keyboard and it's not from a recent mouse click
      if (usingKeyboard && !isRecentMouseInteraction) {
        $(e.target).addClass('focus');
      } else {
        // Remove focus class if it was added by mouse interaction
        $(e.target).removeClass('focus');
      }
      
      // Handle modal-specific focus trapping
      var openModals = $('.size-chart-modal-desktop:not([hidden]), .size-chart-modal-mobile:not([hidden])');
      if (openModals.length > 0) {
        // Check if the focus target is within any open modal
        var targetModal = null;
        openModals.each(function() {
          if (this.contains(e.target)) {
            targetModal = this;
            return false; // break out of each loop
          }
        });
        
        // If focus is trying to go outside all modals, redirect to the first open modal
        if (!targetModal) {
          var modal = openModals[0];
          e.preventDefault();
          e.stopPropagation();
          
          // Find the first focusable element in the modal
          var focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
          var firstFocusable = modal.querySelector(focusableSelectors);
          
          if (firstFocusable) {
            firstFocusable.focus();
          } else {
            modal.focus();
          }
        }
      }
    })
    
    // Remove focus class when element loses focus
    $(document).on('focusout', function(e) {
      $(e.target).removeClass('focus');
    })

    document.body.appendChild(s);
  }, 50);
})(jQuery);
